// Experiment for Budget Intake Tool
import { productUsers, engineeringUsers } from "./experiment-utils";

export const shouldEnableBudgetIntakeTool = (userEmail: string): boolean => {
  const budgetIntakeToolUsers: string[] = [
    "miguel.garcia@tinuiti.com",
    "micah.kilimann@tinuiti.com",
    "ben.plantz@tinuiti.com",
    "sandra.moy@tinuiti.com",
    "eykis.chavarro@tinuiti.com",
    "travis.webster@tinuiti.com",
    "connor.schrack@tinuiti.com",
    "holly.block@tinuiti.com",
    "hunter.lindgren@tinuiti.com",
    "lauren.walden@tinuiti.com",
    "matt.orlando@tinuiti.com",
    "vicky.conti@tinuiti.com",
    "kaitlin.stokes@tinuiti.com",
    "jackie.siegel@tinuiti.com",
    "jevons.wang@tinuiti.com",
    "brian.smith@tinuiti.com",
    "elizabeth.hunter@tinuiti.com",
    ...productUsers,
    ...engineeringUsers,
    // Add users here!
  ];
  return budgetIntakeToolUsers.includes(userEmail);
};
